import {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailure,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailure,
  updateUserStatusStart,
  updateUserStatusSuccess,
  updateUserStatusFailure,
} from "./reducer";

import {
  deleteUserService,
  getAllUserListService,
  updateUserStatusService,
} from "../../../Services/UserService";
import { toast } from "react-toastify";

export const fetchUserList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchUsersStart());
      const response = await getAllUserListService(params);

      if (params.isPagination === 0) {
        dispatch(
          fetchUsersSuccess({
            users: response.data,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchUsersSuccess({
            users: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchUsersFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchUsersFailure(error));
    }
  };

export const deleteUser = (userId) => async (dispatch) => {
  try {
    dispatch(deleteUserStart());
    await deleteUserService(userId);
    dispatch(deleteUserSuccess(userId));
    toast.success("User deleted successfully");
    dispatch(fetchUserList());
  } catch (error) {
    toast.error(error || "Something went wrong");
    dispatch(deleteUserFailure(error));
  }
};

export const updateUserStatus =
  (userId, active) => async (dispatch, getState) => {
    try {
      dispatch(updateUserStatusStart());

      const response = await updateUserStatusService(userId, active);
      if (response?.success) {
        const state = getState();
        const user = state.UserList.users.find((u) => u.id === userId);

        if (user) {
          const updatedUser = { ...user, active };
          dispatch(updateUserStatusSuccess(updatedUser));
        }

        toast.success(response.message || "User status updated successfully");
      } else {
        dispatch(updateUserStatusFailure("Failed to update user status"));
        toast.error("Failed to update user status");
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
      dispatch(updateUserStatusFailure(error));
    }
  };
